import { clone } from '../../../utility/immutability.util.service';
import * as SearchActions from '../../../state/search/search.action';

class FilterOverviewComponent {
  constructor($state, $ngRedux) {
    'ngInject';

    this.$state = $state;
    this.store = $ngRedux;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
  }

  mapStateToThis(state) {
    const { search } = state;
    const { query } = search;
    const appliedFilters = buildFilterReview(search);

    return {
      searchString: query,
      loading: search.inProgress,
      search: search,
      appliedFilters,
      showOverview:
        query.length > 0 || appliedFilters.filtersCount > 0 || Object.keys(appliedFilters.tags || {}).length > 0
    };
  }

  deselectAlert(value) {
    this.deselectFacet(SearchActions.ALERTS_FACET_TYPE, value);
  }

  deselectMaintenance(value) {
    this.deselectFacet(SearchActions.MAINTENANCE_STATUS_FACET_TYPE, value);
  }

  deselectLastCommunicated(value) {
    this.deselectFacet(SearchActions.COMMUNICATED_AT_FACET_TYPE, value);
  }

  deselectSecurityGroup(value) {
    this.deselectFacet(SearchActions.SECURITY_GROUPS_FACET_TYPE, value);
  }

  deselectAccount(account) {
    this.removeAccount(account);
  }

  deselectLastSeen() {
    this.updateLastSeen(null);
  }

  removeSearchTerm(value) {
    this.removeQuery(value);
  }

  removeTagFilter(key) {
    this.removeTAGFilter(key);
  }

  clearAll() {
    this.resetSearch();
  }

  isArray(value) {
    return Array.isArray(value);
  }

  toggleAccordion() {
    let panel = document.getElementById('panel');
    let button = document.getElementById('toggle-accordion');
    panel.classList.toggle('close');
    button.classList.toggle('toggle-hide');
  }
}

const buildFilterReview = search => {
  const selectedAlerts = search.alerts.filter(alert => alert._selected);
  const selectedMaintenance = search.maintenance.filter(maintenance => maintenance._selected);
  const selectedLastCommunicated = search.lastCommunicated.filter(lastCommunicated => lastCommunicated._selected);
  const selectedSecurityGroups = search.securityGroups.filter(securityGroup => securityGroup._selected);
  const selectedAccounts = search.accounts.filter(accounts => accounts._selected);

  const filtersCount =
    selectedAlerts.length +
    selectedMaintenance.length +
    selectedLastCommunicated.length +
    selectedSecurityGroups.length +
    selectedAccounts.length +
    (search.lastSeen || []).length;
  //TODO: figure out how to parse tag filters
  return {
    alerts: selectedAlerts,
    maintenance: selectedMaintenance,
    lastCommunicated: selectedLastCommunicated,
    securityGroups: selectedSecurityGroups,
    tags: search.tagFilters,
    accounts: search.accounts.filter(acc => acc._selected),
    lastSeen: search.lastSeen,
    filtersCount
  };
};

export default {
  template: require('./filter-overview.html'),
  controller: FilterOverviewComponent,
  controllerAs: 'vm',
  bindings: {}
};
